import { SyntheticEvent } from 'react'

const stopPropagation = (e: SyntheticEvent): void => {
  e.stopPropagation()
}

export default stopPropagation
